import { deepArticles } from "@/mocks/gua";

export default function DeepDive() {
  const [lead, ...rest] = deepArticles;
  return (
    <section id="deep" className="mt-16 scroll-mt-24 px-4 md:mt-24 md:px-6">
      <div className="mx-auto max-w-[1240px]">
        <div className="flex items-center gap-2 border-b-2 border-primary-500 pb-3">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">深度解读 · 慢下来看明白</h2>
          <span className="ml-auto hidden items-center gap-1 text-xs text-foreground-400 sm:inline-flex">
            <i className="ri-book-open-line" /> 单篇 10–15 分钟 · 全链条
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* 主稿 */}
          <article className="group cursor-pointer overflow-hidden rounded-xl border border-background-200 bg-background-100/50 transition-colors hover:border-primary-300 lg:row-span-1">
            <div className="relative overflow-hidden">
              <img
                src={lead.img}
                alt={`${lead.title} 深度报道封面`}
                className="h-56 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105 md:h-72"
              />
              <span className="absolute left-4 top-4 rounded bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                本周主编精选
              </span>
            </div>
            <div className="flex flex-col gap-3 p-5 md:p-6">
              <p className="text-xs font-medium tracking-wide text-secondary-600">{lead.cat}</p>
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                {lead.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{lead.excerpt}</p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                阅读全文 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </article>

          {/* 其余稿件 */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
            {rest.map((a) => (
              <article
                key={a.title}
                className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100/50 transition-colors hover:border-primary-300"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={a.img}
                    alt={`${a.title} 深度报道配图`}
                    className="h-40 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 whitespace-nowrap rounded bg-background-50/90 px-2 py-0.5 text-[11px] text-secondary-700 backdrop-blur">
                    {a.duration}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-2 p-4">
                  <p className="text-[11px] font-medium tracking-wide text-secondary-600">{a.cat}</p>
                  <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                    {a.title}
                  </h3>
                  <p className="mt-auto line-clamp-2 text-xs leading-relaxed text-foreground-500">{a.excerpt}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}